import { useState, useEffect } from 'react';

const getWindowDimensions = () => {
  const {
    pageXOffset: resizePageXOffset,
    pageYOffset: resizePageYOffset,
    screenTop: resizeScreenTop,
    screenLeft: resizeScreenLeft,
    screenX: resizeScreenX,
    screenY: resizeScreenY,
    innerWidth: resizeWidth,
    innerHeight: resizeHeight,
  } = window;
  return {
    resizePageXOffset,
    resizePageYOffset,
    resizeScreenTop,
    resizeScreenLeft,
    resizeScreenX,
    resizeScreenY,
    resizeWidth,
    resizeHeight,
  };
};

/**
 * 브라우저 사이즈 조절할 때, 동적으로 위치 바꾸기 위한 Hook.
 * 다른 use 안에서는 사용할 수 없음으로 window. 으로 대체 사용.
 * @returns {{resizeScreenY: number, resizeScreenX: number, resizeScreenLeft: number, resizePageXOffset: number, resizeWidth: number, resizeScreenTop: number, resizePageYOffset: number, resizeHeight: number}}
 */
export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};

export default useWindowDimensions;
